import { UAParser } from 'ua-parser-js';

export const isMobile = (): boolean => {
  const parser = new UAParser();

  return ['mobile', 'tablet'].includes(parser.getDevice().type ?? '');
};
